import { authInitStorage } from '../storages';
import { generateCodeChallengeFromVerifier, generateCodeVerifier } from '../helpers';
import type { ISamoletConfiguration } from '../types';

export async function goToAuth(config: ISamoletConfiguration) {
  const state = generateCodeVerifier();
  const verifier = generateCodeVerifier();
  const returnUrl = window.location.href;

  const authUrl = config.urls.createAuthUrl({
    state,
    codeChallenge: await generateCodeChallengeFromVerifier(verifier),
    clientId: config.clientId,
  });

  await authInitStorage.setJwtAuthParams({ state, verifier, returnUrl });

  window.location.href = authUrl;

  return Promise.reject();
}
